import { useTranslation } from "react-i18next";
import NavbarComponent from "../components/NavbarComponent";

import "../styles/projects/project-main.css";
import { Container } from "react-bootstrap";
import useLocalizedProjects from "../hooks/useLocalizedProjects";
import { useLocation } from "react-router-dom";
import BrowseProjectsComponent from "../components/BrowseProjectsComponent";
import BackButtonComponent from "../components/BackButtonComponent";
import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import AnimatedElement from "../components/AnimatedElement";
import { WebsiteTechnologyBadgeComponent } from "../components/TechnologyBadgeComponent";

const Websites = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const pathname = location.pathname;
  const projectsData = useLocalizedProjects();
  const fetchProjectData = projectsData.data.filter(
    (item) => item.projectLink === pathname
  );
  const projectData = fetchProjectData[0];

  const websitesList: any = [
    {
      id: 1,
      title: "Fizzi Soda",
      projectLink: "",
      imageLink: "/assets/images/project-icons/fizzi-soda.webp",
      technologies: [
        "React",
        "Next.js",
        "Typescript",
        "Tailwind CSS",
        "Zustand",
      ],
    },
    {
      id: 2,
      title: "Fizzi Soda",
      projectLink: "",
      imageLink: "/assets/images/project-icons/fizzi-soda.webp",
      technologies: [
        "React",
        "Next.js",
        "Typescript",
        "Tailwind CSS",
        "Zustand",
      ],
    },
    {
      id: 3,
      title: "Fizzi Soda",
      projectLink: "",
      imageLink: "/assets/images/project-icons/fizzi-soda.webp",
      technologies: [
        "React",
        "Next.js",
        "Typescript",
        "Tailwind CSS",
        "Zustand",
      ],
    },
    {
      id: 4,
      title: "Fizzi Soda",
      projectLink: "",
      imageLink: "/assets/images/project-icons/fizzi-soda.webp",
      technologies: [
        "React",
        "Next.js",
        "Typescript",
        "Tailwind CSS",
        "Zustand",
      ],
    },
    {
      id: 5,
      title: "Fizzi Soda",
      projectLink: "",
      imageLink: "/assets/images/project-icons/fizzi-soda.webp",
      technologies: [
        "React",
        "Next.js",
        "Typescript",
        "Tailwind CSS",
        "Zustand",
      ],
    },
  ];

  return (
    <>
      <NavbarComponent />

      <div className="project-body">
        <Container>
          <BackButtonComponent />

          <h1 className="project-page-title">{projectData.title}</h1>
          <h2 className="project-page-subtitle text-white">
            {projectData.subtitle}
          </h2>

          <Row lg={3} md={2} sm={1} xs={1} className="g-4 pt-4">
            {websitesList.map((website: any, index: number) => (
              <Col key={index}>
                <AnimatedElement>
                  <a href={`${website.projectLink}`}>
                    <Card className="h-100 website-card bg-white">
                      <Card.Img
                        src={`${website.imageLink}`}
                        alt={`Image for ${website.title}`}
                      />
                      <Card.Body className="p-0 px-2">
                        <Card.Title>{website.title}</Card.Title>
                        <Card.Text>
                          {t('websites.cardText')}
                        </Card.Text>
                        <WebsiteTechnologyBadgeComponent
                          technologiesList={website.technologies}
                        />
                      </Card.Body>
                    </Card>
                  </a>
                </AnimatedElement>
              </Col>
            ))}
          </Row>

          <BrowseProjectsComponent projectsListData={projectsData.data} />
        </Container>
      </div>
    </>
  );
};

export default Websites;
